import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withSizes } from 'react-sizes';
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';
import { selectGuests, selectGuestsDefault } from "../../redux/actions";
import { HotelParamsLine, DropdownContainer, AmountCounter, SelectorModalMobile } from "../index";
import { Router } from "../../routes";
import { getCategory, slugify } from '../../utils';
import { initialState } from '../../redux/reducers/userPreferencesReducer';

const initialUserPreferences = initialState;
const { ParamsOption } = HotelParamsLine;

const mapStateToProps = state => ({
  guests: state.userPreferences.guests,
  product: state.userPreferences.product,
  market: state.userPreferences.city.market,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  handleGuestsSelection: selectGuests,
  handleDefaultGuestsSelection: selectGuestsDefault,
}, dispatch);

@connect(mapStateToProps, mapDispatchToProps)
class GuestsSelector extends Component {
  static propTypes = {
    guests: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    isMobile: PropTypes.bool,
    total: PropTypes.number,
    handleGuestsSelection: PropTypes.func,
    currentDropdown: PropTypes.string,
    handleDropdownClick: PropTypes.func,
    handleDefaultGuestsSelection: PropTypes.func,
    handleCloseDropdown: PropTypes.func,
    product: PropTypes.string,
    market: PropTypes.string,
  };

  handleGuestChange = (amount, initial = false) => {
    const { handleGuestsSelection, handleDefaultGuestsSelection, product, market, handleCloseDropdown } = this.props;
    const guests = initial ? initialUserPreferences.guests : amount;

    Router.pushRoute('search', {
      ...Router.query,
      marketName: slugify(market),
      category: getCategory(product),
      guests,
    }, { shallow: true });

    if (initial) {
      handleDefaultGuestsSelection();
      handleCloseDropdown();
      return;
    }

    handleGuestsSelection(amount);
  };

  render() {
    const { guests, currentDropdown, handleDropdownClick, handleCloseDropdown, isMobile, total } = this.props;
    const { handleGuestChange } = this;
    const guestAmount = Number(guests);

    return (
      <Fragment>
        <ParamsOption
          type="button"
          name="guests"
          onClick={handleDropdownClick}
          isOpened={currentDropdown === 'guests'}
          isActive={guests >= 1}
        >
          {guests ? `${guests} guest${guests > 1 ? 's' : ''}` : 'Guests amount'}
        </ParamsOption>
        {currentDropdown === 'guests' && !isMobile && (
          <DropdownContainer name="guests" handleCloseButtonClick={handleCloseDropdown} onClickOutside={handleCloseDropdown}>
            <AmountCounter
              handleChange={handleGuestChange}
              guestAmount={guestAmount}
              label="Guests"
            />
          </DropdownContainer>
        ) || currentDropdown === 'guests' &&
        (
          <SelectorModalMobile name="guests" handleCloseButtonClick={handleCloseDropdown} handleClearButtonClick={() => handleGuestChange(null, true)} total={total} title={`${guests} guests`}>
            <AmountCounter
              handleChange={handleGuestChange}
              guestAmount={guestAmount}
              label="Guests"
            />
          </SelectorModalMobile>
        )}
      </Fragment>
    );
  }
}

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 768,
});

export default withSizes(mapSizesToProps)(GuestsSelector);
